import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToast, Box, Text, Grid } from '@chakra-ui/react';
import React from 'react';
import { useEffect } from 'react';
import { styles } from './toast.styles';
import { ToastPositions, ToastVariants } from '../../core/enums';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const Toast = (props)=>{
    const { feedback, duration = 5000, position = ToastPositions.BOTTOM } = props;
    const toast = useToast();
    const classes = styles(feedback.status ?? ToastVariants.SUCCESS);
    const getIcon = (variant)=>{
        switch(variant){
            case ToastVariants.SUCCESS:
                {
                    return /*#__PURE__*/ _jsx(BiomeIcon, {
                        iconName: IconName.Check_Circle,
                        iconClass: `${classes.successIcon}`,
                        iconSize: "12",
                        titleText: "Success"
                    });
                }
            case ToastVariants.INFO:
            case ToastVariants.WARNING:
                {
                    return /*#__PURE__*/ _jsx(BiomeIcon, {
                        iconName: IconName.Info,
                        iconClass: `${classes.infoIcon}`,
                        titleText: "Info"
                    });
                }
            case ToastVariants.ERROR:
                {
                    return /*#__PURE__*/ _jsx(BiomeIcon, {
                        iconName: IconName.Cancel_Circle,
                        iconClass: `${classes.calendarIcon}`,
                        titleText: "Cancel"
                    });
                }
            default:
                {
                    console.warn('Invalid variant ', variant);
                    break;
                }
        }
    };
    useEffect(()=>{
        if (feedback.message) {
            toast({
                duration: duration,
                position: position,
                status: 'error',
                isClosable: true,
                render: ({ onClose })=>{
                    return /*#__PURE__*/ _jsxs(Box, {
                        sx: classes?.container,
                        children: [
                            /*#__PURE__*/ _jsxs(Grid, {
                                sx: classes?.grid,
                                children: [
                                    getIcon(feedback.status ?? ToastVariants.SUCCESS),
                                    /*#__PURE__*/ _jsx(Text, {
                                        sx: classes?.text,
                                        children: feedback.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Grid, {
                                sx: classes?.icon,
                                "data-testId": "close",
                                onClick: onClose,
                                children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                    iconName: IconName.Cancel,
                                    titleText: "Close"
                                })
                            })
                        ]
                    });
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        feedback
    ]);
    return null;
};
Toast.displayName = 'Toast';
export { Toast };
